import type { Dict } from "../lib/i18n";

// Shared strings: common.*, error.*, photo.*, nav.*, home.*, auth.*, account.*, plans.*, reminder.*, weather.*
export default {
  zh: {
    "home.tagline": "买菜、记账、吃得健康，一个 App 就够了",
    "home.quick.title": "常用",
    "home.quick.receipt": "拍小票",
    "home.quick.list": "加清单",
    "home.quick.meal": "记一餐",
    "home.quick.pantry": "放食材",
    "home.freeLine": "注册后，购物清单、会员卡包、附近商家、邻里分享永久免费",
    "today.arrangeShort": "排列",
    "common.needName": "请先写上名称",
    "free.board": "邻里分享",
    "free.boardSub": "和同城邻居分享美食、交换闲置、互相帮忙",
    "auth.terms": "注册后可免费试用全部功能 14 天，不需要绑卡；购物清单、会员卡包、附近商家和邻里分享永久免费。注册即表示你同意《用户条款》和《隐私政策》。你可以随时导出或删除全部数据。",
    "home.all": "全部功能",
    "home.more": "更多功能",
    "focus.prev": "上一个",
    "focus.next": "下一个",
    "free.badge": "注册后永久免费",
    "free.title": "注册后永久免费",
    "free.intro": "不用绑卡。试用结束后也一直能用，永远不收费。",
    "free.shopping": "购物清单",
    "free.shoppingSub": "按分类整理，可以说话添加，买完打勾",
    "free.cards": "会员卡包",
    "free.cardsSub": "所有超市会员卡放在一起，结账时出示条码",
    "free.places": "附近商家",
    "free.placesSub": "看附近的超市、餐馆和优惠",
    "free.export": "导出我的数据",
    "free.exportSub": "随时把自己的全部数据导出成 Excel",
    "free.support": "联系客服",
    "free.supportSub": "用你自己的语言写，我们用你的语言回复",
    "today.title": "今天",
    "today.arrange": "排列卡片",
    "today.arrangeHint": "用箭头把最常看的放在最上面；点眼睛可以隐藏不需要的卡片。",
    "today.up": "往上移",
    "today.down": "往下移",
    "today.show": "显示这张卡片",
    "today.hide": "隐藏这张卡片",
    "today.health.title": "今日健康",
    "today.budget.title": "本月预算",
    "today.budget.left": "还剩",
    "today.budget.over": "已超出预算 {amount}",
    "today.budget.canSpend": "这个月还能花 {amount}",
    "today.budget.leftOver": "这个月省下了 {amount}",
    "today.budget.spentOf": "已花 {spent}，预算 {budget}",
    "today.budget.spent": "本月已花",
    "today.budget.empty": "这个月还没有记账",
    "today.budget.start": "拍一张小票就开始",
    "today.budget.setOne": "设一个每月预算，就能看到还剩多少",
    "today.budget.noBudget": "还没有设预算",
    "today.budget.setOneLong": "点下面“设预算”，填每个月最多想花多少。圆环就会显示还剩多少，就像手机电量一样。",
    "today.budget.perDay": "离月底还有 {days} 天，平均每天可以花 {amount}。",
    "today.budget.pairIn": "收入",
    "today.budget.pairOut": "支出",
    "today.fridge.title": "食材库",
    "today.fridge.empty": "食材库还是空的",
    "today.fridge.emptySub": "拍小票或扫条码，买的东西就会放进来",
    "today.fridge.expired": "{n} 样过期了，一定要扔掉",
    "today.fridge.check": "{n} 样过了最佳食用期，先检查",
    "today.fridge.soon": "{n} 样快到期，先吃它们",
    "today.fridge.fresh": "都很新鲜",
    "today.fridge.freshSub": "没有快过期的，放心吃",
    "today.fridge.todoSub": "食材库里一共 {n} 样",
    "today.fridge.todoUnit": "样要处理",
    "today.fridge.itemsUnit": "样食材",
    "today.shopping.title": "购物清单",
    "today.shopping.unit": "样要买",
    "today.shopping.toBuy": "还要买 {n} 样",
    "today.shopping.done": "都买齐了",
    "today.shopping.sub": "去超市前看一眼，买完打勾",
    "error.frozen": "它在冷冻室里，要先解冻。",
    "error.expired": "已过保质期，冷冻也不安全了，请扔掉。",
    "support.title": "联系客服",
    "support.stripSub": "有问题或建议？用你自己的语言写给我们",
    "support.intro": "AI 助手会马上回答你。它答不了的问题会转给真人客服，我们用你的语言回复（通常 1 个工作日内）。可以附一张截图。",
    "support.ai": "AI 助手（自动回答，可能出错）",
    "support.whatsapp": "用 WhatsApp 联系",
    "support.waText": "你好，我是 NutriCart 用户，",
    "support.empty": "还没有消息。在下面写下你的问题吧。",
    "support.team": "NutriCart 客服",
    "support.placeholder": "写下你的问题或建议……",
    "support.photo": "截图",
    "support.send": "发送",
    "support.unread": "客服回复了你（{n}）",
    "support.inbox": "客服消息",
    "support.inboxEmpty": "还没有用户来信。",
    "support.replyPh": "用中文回复，系统会翻译成对方的语言",
    "support.reply": "回复",
    "support.original": "原文",
    "view.mode": "显示方式",
    "view.cards": "卡片",
    "view.table": "表格",
    "view.save": "保存 Excel",
    "view.empty": "这一页还没有内容。",
    "view.truncated": "这里显示前 3000 行，完整内容请点“保存 Excel”。",
    "view.hint": "表格可以左右、上下滑动。想留存或发给别人，点右上角“保存 Excel”。",
    "file.copyLink": "复制下载链接",
    "file.copyHint": "复制后打开 Safari 或 Chrome，粘贴到地址栏，文件就会下载（不用登录，10 分钟内有效）。",
    "file.copied": "已复制。打开 Safari 或 Chrome，粘贴到地址栏就会下载。",
    "file.hintAndroid": "点“直接下载”：文件会保存到手机的「下载」里。点下载完成的通知，或在「文件 › 下载」里，用 Excel、WPS 或 Google 表格打开。",
    "common.exportExcel": "导出 Excel",
    "admin.inquiries.title": "商家合作申请",
    "admin.inquiries.none": "还没有商家申请。",
    "admin.inquiries.done": "标记为已处理",
    "admin.inquiries.reopen": "标记为未处理",
    "legal.privacy": "隐私政策",
    "legal.terms": "用户条款",
    "legal.refund": "退款政策",
    "legal.imprint": "公司信息",
    "legal.missing": "（待补充）",
    "legal.englishNote": "本页以英文显示。",
    "health.consent.title": "使用饮食和健康功能前，请先同意",
    "health.consent.body": "饮食记录、餐食照片、体重和身体数据属于健康数据。按照欧盟隐私法（GDPR），我们需要你明确同意后才能保存和处理它们。",
    "health.consent.what": "会保存：你记录的饮食和照片、体重、性别、出生年份、身高、运动和步数。",
    "health.consent.why": "只用来给你计算热量、营养、消耗和今天的健康状态，不用于广告。",
    "health.consent.private": "只有你自己能看到，不会共享给家人。",
    "health.consent.withdraw": "你可以随时在“我的”里撤回同意，或删除这些记录。",
    "health.consent.agree": "我同意处理我的健康数据",
    "health.consent.notNow": "暂不，返回首页",
    "health.consent.given": "健康数据：已同意",
    "health.consent.givenSub": "点这里可以撤回",
    "health.consent.withdrawBody": "撤回后，饮食和健康功能会停止，我们不再处理新的健康数据。已经保存的饮食和体重记录可以在饮食页里删除，或删除整个账号。",
    "health.consent.withdrawBtn": "撤回同意",
    "health.consent.withdrawn": "已撤回同意。",
    "error.family_needs_plus": "这个家庭现在没有 Plus，暂时不能加入。请家里订阅 Plus 的人续订。",
    "account.family": "家庭",
    "account.familyInvite": "邀请家人加入",
    "account.familySub": "全家共用清单、账本、食材库、物品库和一个 Plus",
    "error.family_full": "这个家庭已经有 {max} 个人了，不能再加入。",
    "error.list_has_members": "你自己的清单正在和家人共享，不能再加入别人的清单。先在“和家人共享”里停止共享。",
    "ocr.failNoReads": "本月的 AI 帮读次数（{limit} 次）已经用完，1 日恢复；在那之前只靠手机识别。拍正、拍亮、离近一点，手机通常就能读出来。",
    "ocr.withAi": "手机没读清，正在请 AI 帮忙读…",
    "error.ai_reads_reached": "本月的 AI 帮读次数（{limit} 次）已用完，下个月 1 日恢复。现在可以手动填写或核对一下数字。",
    "ocr.preparing": "正在准备手机上的识别引擎（第一次约需下载 7 MB）…",
    "auth.remember": "30 天内免登录",
    "auth.rememberSub": "常用的话会一直保持登录。在别人的电脑上请取消勾选。",
    "error.crashTitle": "哎呀，这一页出了点小问题",
    "error.crashBody": "你的数据都安全保存着。点下面重新打开这一页；问题已经自动报告给我们了。",
    "error.crashReload": "重新打开",
    "photo.drop": "把照片拖到这里，或点这里选择文件",
    "photo.dropSub": "也可以直接粘贴（⌘V / Ctrl+V）。用手机拍照更方便。",
    "photo.file": "换一张照片",
    "error.ai_daily_limit_trial": "试用期间每天可以拍照估算 {limit} 次，明天再来。订阅 Plus 后每天 {plus} 次（早、中、晚）。扫条形码、拍食品包装、手动记录都不限次数。",
    "ai.leftTodayTrial": "试用期间每天可拍照估算 {limit} 次，今天还剩 {n} 次。订阅 Plus 后每天 {plus} 次。",
    "error.ai_advice_limit": "这个月的记账建议已经写了 {limit} 次，下个月 1 日再来。上面最近一次的建议仍然有效。",
    "error.ai_paused": "本月的 AI 估算名额已经全部用完，下个月 1 日恢复。现在可以扫条形码、拍食品包装或手动记录，都不受影响。",
    "admin.cost.budget": "本月安全上限：${budget}。它随付费和试用人数自动增长（按每人用满额度再加 50%），正常使用碰不到；花到 80% 时会发邮件提醒你。最低值在 Railway 的 AI_MONTHLY_BUDGET_USD 修改。",
    "admin.statGroup.people": "用户",
    "admin.statGroup.money": "订阅和收入",
    "admin.statGroup.usage": "使用情况",
    "admin.stat.users": "注册用户",
    "admin.stat.newThisWeek": "本周新注册",
    "admin.stat.newThisMonth": "本月新注册",
    "admin.stat.activeThisWeek": "本周登录过",
    "admin.stat.revenuePerMonthEur": "每月订阅收入（含税）",
    "admin.stat.subscribersYearly": "年订阅",
    "admin.stat.subscribersMonthly": "月订阅",
    "admin.stat.inTrial": "试用中",
    "admin.stat.gifted": "赠送 Plus",
    "admin.stat.freeOnly": "只用免费功能",
    "admin.stat.revenueHint": "每月收入是估算：月订阅人数 × €9.99 +（年订阅人数 × €89，创始会员 × €69）÷ 12，未扣 Stripe 手续费和增值税。实际到账以 Stripe 后台为准。",
    "admin.members.title": "会员",
    "admin.members.search": "搜索邮箱或名字",
    "admin.members.filter": "按状态筛选",
    "admin.members.s.all": "全部",
    "admin.members.s.subscriber": "已订阅",
    "admin.members.s.trial": "试用中",
    "admin.members.s.gifted": "赠送",
    "admin.members.s.free": "免费",
    "admin.members.s.admin": "管理员",
    "admin.members.none": "没有找到符合条件的会员。",
    "admin.members.first100": "只显示最新的 100 位，请用搜索缩小范围。",
    "admin.members.subYear": "年订阅",
    "admin.members.subMonth": "月订阅",
    "admin.members.giftedUntil": "赠送 Plus 到 {date}",
    "admin.members.giftedForever": "赠送 Plus，永久",
    "admin.members.trialUntil": "试用到 {date}",
    "admin.members.joined": "{date} 注册",
    "admin.members.status": "状态",
    "admin.members.since": "注册日期",
    "admin.members.lastLogin": "最近登录",
    "admin.members.isAdmin": "管理员本来就能使用全部功能。",
    "admin.members.giftTitle": "赠送免费 Plus",
    "admin.members.giftHint": "适合亲友、测试用户、合作商家。赠送期间不需要付费；到期后自动恢复原来的状态（订阅、试用或免费）。",
    "admin.members.for.1": "1 个月",
    "admin.members.for.3": "3 个月",
    "admin.members.for.12": "1 年",
    "admin.members.for.forever": "永久",
    "admin.members.for.date": "选日期",
    "admin.members.until": "到哪一天为止（含当天）",
    "admin.members.endsOn": "到 {date} 为止",
    "admin.members.noEnd": "没有截止日期，直到你取消为止。",
    "admin.members.note": "备注（只有管理员看得到）",
    "admin.members.noteHint": "例如：测试用户、合作商家阿尔伯特海恩",
    "admin.members.grant": "赠送 Plus",
    "admin.members.change": "保存修改",
    "admin.members.granted": "已赠送 Plus",
    "admin.members.revoke": "取消赠送",
    "admin.members.revoked": "已取消赠送",
    "ads.label": "广告 · 合作商家",
    "ads.close": "关闭这条广告（7 天内不再显示）",
    "ads.open": "查看优惠",
    "admin.partner.placements": "在哪里展示",
    "admin.placement.home": "首页",
    "admin.placement.list": "购物清单",
    "admin.placement.places": "附近商家",
    "admin.placement.fridge": "食材库",
    "admin.partner.endsOn": "广告截止日期",
    "admin.partner.endsOnHint": "合作到期后自动停止展示；不填则一直展示",
    "admin.partner.until": "到 {date}",
    "admin.ads.title": "广告统计",
    "admin.ads.month": "月份",
    "admin.ads.hint": "只统计次数，不记录是谁看的、谁点的。每个位置显示为“展示/点击”。",
    "admin.ads.none": "这个月还没有广告展示。",
    "admin.ads.partner": "商家",
    "admin.ads.views": "展示",
    "admin.ads.clicks": "点击",
    "admin.ads.ctr": "点击率",
    "admin.ads.download": "下载本月广告报告（Excel 可打开）",
    "admin.ads.downloaded": "报告已下载",
    "admin.cost.title": "AI 费用",
    "admin.cost.spent": "本月已花",
    "admin.cost.projected": "预计到月底",
    "admin.cost.calls": "本月 AI 次数（拍饭菜 {food}）",
    "admin.cost.perUser": "每个付费用户（共 {n} 人）",
    "admin.cost.recommend": "建议在 Anthropic 后台把每月花费上限设为 ${usd}",
    "admin.cost.how": "console.anthropic.com → Limits → Spend limit。这个数约为预计花费的 2.5 倍：正常使用碰不到，意外时能挡住。用户越多，这里建议的数会自动变大，每月看一次再调整。",
    "admin.cost.details": "上个月 AI 共花 ${last}；平均每次 ${perCall}。最坏情况（所有付费和试用用户都把次数用满）每月约 ${worst}。以上按美元估算，以 Anthropic 账单为准。",
    "ai.leftToday": "今天还能拍照估算 {n} 次（每天 {limit} 次：早、中、晚）",
    "error.ai_daily_limit": "今天的 {limit} 次拍照估算已经用完，明天会恢复。现在可以扫条形码、拍食品包装或手动记录，都不限次数。",
    "account.clock": "日期和时间",
    "account.clockZone": "时区：{zone}。App 里所有日期和时间都按这部手机的时间记录；如果不对，请在手机的“设置 → 通用 → 日期与时间”里打开“自动设置”。",
    "admin.reset": "帮用户重设密码",
    "admin.resetHint": "用户忘了密码、又收不到邮件时：输入他的注册邮箱，生成一个重设链接（24 小时内有效，只能用一次），复制后通过微信或短信发给他。",
    "admin.resetMake": "生成重设链接",
    "admin.resetMade": "链接已生成",
    "admin.copy": "复制链接",
    "admin.copied": "已复制",
    "admin.copyManually": "请长按上面的链接手动复制",
    "auth.title.login": "登录",
    "auth.title.register": "创建账号",
    "auth.title.forgot": "找回密码",
    "auth.title.reset": "设置新密码",
    "auth.submit.login": "登录",
    "auth.submit.register": "注册",
    "auth.submit.forgot": "发送重设邮件",
    "auth.submit.reset": "保存新密码并登录",
    "auth.forgot": "忘记密码？",
    "auth.forgotIntro": "输入注册时用的邮箱，我们会发一封邮件，点里面的链接就能设置新密码。",
    "auth.resetIntro": "请输入新密码，输入两次确认。",
    "auth.forgotSent": "如果 {email} 注册过 NutriCart，重设密码的邮件已经发出，1 小时内有效。没收到的话，看看垃圾邮件文件夹。",
    "auth.forgotUnavailable": "找回密码的邮件服务还没有开通。请联系管理员帮你重设密码。",
    "auth.backToLogin": "返回登录",
    "auth.newPassword": "新密码",
    "auth.confirmPassword": "再输入一次密码",
    "auth.passwordMismatch": "两次输入的密码不一样。",
    "auth.showPassword": "显示密码",
    "auth.hidePassword": "隐藏密码",
    "error.reset_link_invalid": "这个重设链接已经失效（超过 1 小时或已经用过）。请重新申请找回密码。",
    "error.mail_failed": "邮件暂时发不出去，请稍后再试。",
    "reminder.openList": "打开购物清单",
    "error.already_fasting": "已经在断食中了。",
    "error.not_fasting": "现在没有进行中的断食。",
    "error.end_before_start": "结束时间要晚于开始时间。",
    "error.time_out_of_range": "时间不能晚于现在，也不能早于 3 天前。",
    "common.retrying": "正在重新连接…",
    "common.offlineBar": "网络断开，正在重新连接…",
    "common.updateBar": "有新版本",
    "common.updateNow": "点这里更新",
    "common.refresh": "刷新",
    "common.back": "返回",
    "common.close": "关闭",
    "common.cancel": "取消",
    "common.save": "保存",
    "common.saved": "已保存",
    "common.delete": "删除",
    "common.edit": "编辑",
    "common.add": "添加",
    "common.done": "完成",
    "common.retry": "重试",
    "common.loading": "加载中…",
    "common.restore": "恢复",
    "common.restored": "已恢复",
    "common.undo": "撤销",
    "common.trash": "回收站",
    "common.movedToTrash": "已移到回收站",
    "common.deleteForever": "永久删除",
    "common.search": "搜索",
    "common.showAll": "全部显示 · {n}",
    "common.showLess": "收起",
    "common.optional": "选填",
    "common.today": "今天",
    "common.yesterday": "昨天",
    "common.more": "更多",
    "common.continue": "继续",
    "common.yes": "是",
    "common.no": "否",
    "common.discardTitle": "放弃这次修改？",
    "common.discardBody": "还没保存的内容会丢失。",
    "common.discard": "放弃",
    "common.keepEditing": "继续编辑",

    "nav.home": "首页",
    "nav.shopping": "清单",
    "nav.ledger": "账本",
    "nav.meals": "饮食",
    "nav.fridge": "食材库",
    "nav.me": "我的",

    "error.generic": "出了点问题，请稍后再试。",
    "error.already_subscribed": "你已经订阅了 Plus，不需要再订阅。要更换按月/按年，请点“管理订阅”。",
    "error.no_subscription": "没有找到你的订阅。如果刚付完款，请稍等一分钟再试。",
    "error.photo_limit": "今天上传的照片已经很多了（{limit} 张），明天再继续。",
    "error.subscription_cancel_failed": "暂时没能取消你的 Plus 订阅，所以账号还没有删除（避免继续扣款）。请稍后再试，或先在“管理订阅”里取消。",
    "file.ready": "Excel 文件已准备好",
    "file.share": "保存或发送",
    "file.hint": "最方便：点“保存或发送”，在手机菜单里选「存储到“文件”」，或用 Excel、Numbers、WPS 打开，也可以发到微信或邮件。也可以点“直接下载”：会打开一个新窗口显示文件，点「更多…」或分享按钮就能存到「文件」或用 Excel 打开；看完点左上角「完成」回到 App。",
    "file.hintDownload": "点“直接下载”：会打开一个新窗口显示文件，点「更多…」或分享按钮就能存到「文件」或用 Excel、Numbers、WPS 打开；看完点左上角「完成」（或关掉这个页面）回到 App。",
    "file.download": "直接下载",
    "file.failed": "这台手机没能打开分享菜单（{code}）。请点“直接下载”。",
    "file.inWechat": "你是在微信里打开的 App，微信不允许保存文件。请点右上角「···」，选「在默认浏览器中打开」（苹果手机是 Safari），再导出一次。",
    "file.inApp": "你是在其他 App 里打开的网页，可能无法保存文件。请用 Safari 或 Chrome 打开 App，再导出一次。",
    "error.offline": "连不上服务器。请检查网络后重试。",
    "error.timeout": "这次等得太久了，已经停下。请再试一次，或者先手动填写。",
    "error.cancelled": "已取消。",
    "error.server_error": "服务器出错了，请稍后再试。",
    "error.not_found": "找不到这条内容，可能已被删除。",
    "error.invalid_input": "请检查填写的内容。",
    "error.invalid_input_detail": "请检查填写的内容（{detail}）。",
    "error.rate_limited": "操作太频繁了，请稍等一会儿。",
    "error.not_signed_in": "请先登录。",
    "error.forbidden": "你没有权限进行这个操作。",
    "error.too_large": "文件太大了。",
    "error.photo_too_large": "照片太大了，请换一张。",
    "error.invalid_photo": "这张照片无法使用，请换一张。",
    "error.wrong_credentials": "邮箱或密码不正确。",
    "error.email_taken": "这个邮箱已经注册过了，请直接登录。",
    "error.ai_not_configured": "AI 识别暂未开通，请手动填写。",
    "error.ai_quota_reached": "本月 {limit} 次 AI 识别已用完，下个月 1 日恢复。手动填写不受影响。",
    "error.ai_refused": "AI 无法处理这张图片，请手动填写。",
    "error.ai_incomplete": "AI 没能读完整，请重试或手动填写。",
    "error.ai_unavailable": "AI 服务暂时不可用，请稍后重试或手动填写。",
    "error.upstream_error": "外部服务暂时不可用，请稍后再试。",
    "error.download_failed": "下载失败，请重试。",
    "error.date_in_future": "日期不能晚于今天。",
    "error.free_sugar_exceeds_sugar": "添加糖不能多于总糖。",
    "error.sugar_exceeds_carbs": "糖不能多于碳水化合物。",
    "error.min_exceeds_max": "最小值不能大于最大值。",
    "error.reserve_exceeds_ceiling": "必要开支储备不能超过预算上限。",
    "error.card_needs_code_or_photo": "请至少填写卡号、条形码或添加一张照片。",

    "photo.camera": "拍照",
    "photo.library": "相册 / 文件",
    "photo.remove": "移除照片",
    "photo.preparing": "正在处理照片…",
    "photo.unreadable": "无法读取这张图片，请换一张 JPG 或 PNG。",

    "usage.title": "AI 使用情况",
    "usage.count": "{used} / {limit}",
    "usage.left": "还剩 {n} 次，{when}。",
    "usage.none": "已用完，{when}。",
    "usage.daily": "每天 0 点重新计算",
    "usage.monthly": "每月 1 日重新计算",
    "usage.food": "今天拍照估算饭菜",
    "usage.foodNote": "早、中、晚各一次。",
    "usage.advice": "本月记账建议",
    "usage.adviceNote": "账目没变时再看不算次数。",
    "usage.total": "本月 AI 总次数（拍餐 + 记账建议）",
    "usage.totalNote": "",
    "usage.reads": "本月 AI 帮读（小票、营养表、会员卡）",
    "usage.readsNote": "只有手机自己读不出来时才用，手机读出来的不算。",
    "usage.trialPaid": "你已订阅 Plus。试用期结束、第一次扣款后，自动变成 Plus 的次数：每天拍餐 {food} 次，每月 AI 共 {total} 次，AI 帮读 {reads} 次。",
    "usage.trialMore": "订阅 Plus 后：每天拍餐 {food} 次，每月 AI 共 {total} 次，AI 帮读 {reads} 次。",
    "usage.free": "不限次数、不算次数：扫条形码、手机识别小票和营养表、手动记录、购物清单、卡包、附近商店。同一张照片再识别也不算次数。",
    "error.community_rate_limit": "发得太快了：每小时最多发 5 条帖子、30 条评论。请稍后再发。",
    "ai.adviceLeft": "本月还可生成 {n} 次记账建议（每月 {limit} 次，1 日重新计算；账目没变时再看不算次数）。",
    "ai.readsLeft": "手机读不出来时由 AI 帮读：本月还剩 {n} 次（每月 {limit} 次，1 日重新计算）。手机自己读出来的不算次数。",
    "ai.left": "本月还可使用 {n} 次 AI 识别",
    "ai.cached": "已使用之前的识别结果，不消耗次数。",
    "ai.privacy": "照片会发送给 Anthropic 的 Claude 进行识别，不会用于训练模型。",

    "auth.tagline": "购物清单、会员卡、家庭账本和健康饮食，一个 App 搞定。",
    "auth.login": "登录",
    "auth.register": "注册",
    "auth.email": "邮箱",
    "auth.password": "密码",
    "auth.passwordHint": "至少 8 个字符",
    "auth.name": "怎么称呼你",
    "auth.haveAccount": "已经有账号？",
    "auth.noAccount": "还没有账号？",
    "auth.createAccount": "创建账号",
    "auth.passwordTooShort": "密码至少需要 8 个字符。",

    "home.hello": "你好，{name}",
    "home.helloAnon": "你好",
    "home.prompt": "今天想做什么？",
    "home.shopping": "购物清单",
    "home.shopping.sub": "列好清单再出门",
    "home.cards": "会员卡包",
    "home.cards.sub": "结账时出示",
    "home.fridge": "食材库",
    "home.goods": "家庭物品库",
    "home.fridge.sub": "营养、到期和补货",
    "home.receipt": "拍小票",
    "home.receipt.sub": "拍照或手动记一笔",
    "home.ledger": "家庭账本",
    "home.ledger.sub": "收支、预算和报表",
    "home.meals": "饮食",
    "home.meals.sub": "记录三餐",
    "home.places": "附近商家",
    "home.places.sub": "超市和合作商家",
    "home.board": "邻里分享",
    "home.board.sub": "美食、二手、互助",
    "home.monthSpent": "本月已花",
    "home.listOpen": "清单上还有 {n} 件",

    "reminder.title": "出门前的小叮咛",
    "reminder.sub": "购物袋带上，安心出门。",
    "reminder.bags": "购物袋和清单带了吗？顺便看看食材库里还有什么。",
    "reminder.keys": "钥匙、手机、钱包都在身上吗？",
    "reminder.stove": "炉灶和电器都关好了吗？",
    "reminder.windows": "窗户和水龙头关好了吗？",
    "reminder.wish": "祝你购物愉快，早点回家！",

    "weather.enable": "看看出门要不要带伞",
    "weather.enable.sub": "开启定位，获取当地天气提醒",
    "weather.loading": "正在获取天气…",
    "weather.failed": "天气暂时无法更新，点这里重试",
    "weather.denied": "定位被关掉了，看不到天气。请在手机“设置 → 隐私与安全 → 定位服务”里允许浏览器使用定位，然后点这里重试。",
    "weather.now": "现在 {temp}°C",
    "weather.storm": "可能有雷雨，尽量待在室内。",
    "weather.wind": "风很大，注意安全。",
    "weather.rain": "未来几小时可能下雨，记得带伞。",
    "weather.fine": "天气不错，带上购物袋出门吧。",
    "weather.cool": "有点凉，多穿一件。",
    "weather.warm": "天气热，记得喝水。",
    "weather.title": "当地天气",
    "weather.credit": "数据来自挪威气象局 MET Norway（CC BY 4.0）",
    "weather.privacy": "你的位置会四舍五入到约 1 公里，仅用于查询天气。",
    "weather.turnOff": "关闭天气定位",
    "weather.updated": "更新于 {time}",

    "account.title": "我的",
    "account.features": "全部功能",
    "account.profile": "个人资料",
    "account.name": "昵称",
    "account.email": "邮箱",
    "account.language": "语言",
    "account.languageAuto": "跟随手机语言",
    "account.textSize": "字体大小",
    "account.textNormal": "标准",
    "account.textLarge": "大",
    "account.textXLarge": "特大",
    "account.textHint": "整个 App 的文字和按钮一起变大，只对这台手机有效。",
    "account.theme": "外观",
    "account.themeAuto": "跟随系统",
    "account.themeLight": "浅色",
    "account.themeDark": "深色",
    "account.plan": "会员方案",
    "account.aiUsage": "本月 AI 识别：已用 {used} / {limit}",
    "account.password": "修改密码",
    "account.currentPassword": "当前密码",
    "account.newPassword": "新密码",
    "account.passwordChanged": "密码已修改，其他设备已退出登录。",
    "account.data": "我的数据",
    "account.export": "导出我的全部数据（Excel）",
    "account.logout": "退出登录",
    "account.delete": "删除账号",
    "account.deleteBody": "账号和所有数据（账本、照片、会员卡、饮食记录、帖子）都会被永久删除，无法恢复。如果你订阅了 Plus，订阅会同时取消，不会再扣款。请输入密码确认。",
    "account.deleteConfirm": "永久删除",
    "account.install": "添加到主屏幕",
    "account.installBody": "iPhone：在 Safari 里点“分享”→“添加到主屏幕”。Android：在 Chrome 菜单里选“安装应用”。",
    "account.admin": "管理",
    "account.privacy": "隐私说明",
    "account.privacyBody": "你的账本、照片和饮食记录只有你自己能看到，保存在我们位于欧盟的服务器上。只有在你点击 AI 识别、或在“联系客服”里给我们发消息（由 AI 助手回答）时，相关照片、汇总数据或消息才会发送给 Anthropic 的 Claude 处理。邻里分享的帖子对同城用户公开，7 天后自动删除。",


    "admin.title": "管理",
    "admin.stats": "概况",
    "admin.moderation": "被举报的帖子",
    "admin.nothingReported": "暂时没有被举报的内容。",
    "admin.reports": "次举报",
    "admin.hidden": "已隐藏",
    "admin.hide": "隐藏",
    "admin.unhide": "恢复显示",
    "admin.partners": "合作商家",
    "admin.partner.name": "名称",
    "admin.partner.description": "介绍",
    "admin.partner.offer": "优惠",
    "admin.partner.address": "地址",
    "admin.partner.city": "城市",
    "admin.partner.url": "网址（https://…）",
    "admin.partner.category": "类型",
    "admin.partner.active": "在 App 中显示",
    "admin.stat.records": "账目总数",
    "admin.stat.aiCallsThisMonth": "本月 AI 调用",
    "admin.stat.photoMegabytes": "照片占用 MB",
  },
  en: {
    "home.tagline": "Shopping, spending and eating well, in one app",
    "home.quick.title": "Quick actions",
    "home.quick.receipt": "Receipt",
    "home.quick.list": "Add to list",
    "home.quick.meal": "Log a meal",
    "home.quick.pantry": "Pantry",
    "home.freeLine": "With an account, the shopping list, loyalty cards, nearby places and the neighbourhood board are free forever",
    "today.arrangeShort": "Arrange",
    "common.needName": "Please write the name first",
    "free.board": "Neighbourhood board",
    "free.boardSub": "Share food, swap things and help each other with neighbours",
    "auth.terms": "Try every feature free for 14 days, no card needed; the shopping list, loyalty cards, shops nearby and the neighbourhood board are free forever. By signing up you agree to the terms of use and the privacy policy. You can export or delete everything at any time.",
    "home.all": "Everything",
    "home.more": "More",
    "focus.prev": "Previous",
    "focus.next": "Next",
    "free.badge": "Free with account",
    "free.title": "Free forever with an account",
    "free.intro": "No card needed. They keep working after the trial, and never cost anything.",
    "free.shopping": "Shopping list",
    "free.shoppingSub": "Sorted by aisle, add by voice, tick off what you bought",
    "free.cards": "Loyalty cards",
    "free.cardsSub": "All your shop cards in one place, show the barcode at the till",
    "free.places": "Nearby places",
    "free.placesSub": "Shops, restaurants and offers near you",
    "free.export": "Export my data",
    "free.exportSub": "All your data as an Excel file, any time",
    "free.support": "Contact us",
    "free.supportSub": "Write in your own language, we answer in it",
    "today.title": "Today",
    "today.arrange": "Arrange cards",
    "today.arrangeHint": "Use the arrows to put what you look at most on top; tap the eye to hide a card.",
    "today.up": "Move up",
    "today.down": "Move down",
    "today.show": "Show this card",
    "today.hide": "Hide this card",
    "today.health.title": "Today's health",
    "today.budget.title": "This month's budget",
    "today.budget.left": "left",
    "today.budget.over": "{amount} over budget",
    "today.budget.canSpend": "{amount} left to spend this month",
    "today.budget.leftOver": "{amount} saved that month",
    "today.budget.spentOf": "Spent {spent} of {budget}",
    "today.budget.spent": "spent this month",
    "today.budget.empty": "Nothing recorded this month yet",
    "today.budget.start": "Take a photo of a receipt to start",
    "today.budget.setOne": "Set a monthly budget to see how much is left",
    "today.budget.noBudget": "No budget set yet",
    "today.budget.setOneLong": "Tap “Set budget” below and enter the most you want to spend a month. The ring then shows what's left, like a phone battery.",
    "today.budget.perDay": "{days} days to the end of the month: about {amount} a day.",
    "today.budget.pairIn": "Income",
    "today.budget.pairOut": "Spending",
    "today.fridge.title": "Pantry",
    "today.fridge.empty": "The pantry is still empty",
    "today.fridge.emptySub": "Photograph a receipt or scan a barcode to fill it",
    "today.fridge.expired": "{n} past the date: throw away",
    "today.fridge.check": "{n} past best before: check first",
    "today.fridge.soon": "{n} due soon: eat these first",
    "today.fridge.fresh": "All fresh",
    "today.fridge.freshSub": "Nothing about to go off",
    "today.fridge.todoSub": "{n} items in the pantry",
    "today.fridge.todoUnit": "to see to",
    "today.fridge.itemsUnit": "items",
    "today.shopping.title": "Shopping list",
    "today.shopping.unit": "to buy",
    "today.shopping.toBuy": "{n} still to buy",
    "today.shopping.done": "All bought",
    "today.shopping.sub": "Check it before you go; tick off as you shop",
    "error.frozen": "It's in the freezer: thaw it first.",
    "error.expired": "It's past its use-by date: freezing won't make it safe. Please throw it away.",
    "support.title": "Contact us",
    "support.stripSub": "Questions or ideas? Write to us in your own language",
    "support.intro": "The AI helper answers right away. Anything it can't answer goes to a person on our team, who replies in your language (usually within 1 working day). You can add a screenshot.",
    "support.ai": "AI helper (automatic, may be wrong)",
    "support.whatsapp": "Contact us on WhatsApp",
    "support.waText": "Hello, I use NutriCart and ",
    "support.empty": "No messages yet. Write your question below.",
    "support.team": "NutriCart team",
    "support.placeholder": "Your question or idea…",
    "support.photo": "Screenshot",
    "support.send": "Send",
    "support.unread": "The team answered you ({n})",
    "support.inbox": "Support messages",
    "support.inboxEmpty": "No messages yet.",
    "support.replyPh": "Reply in your language; it is translated into theirs",
    "support.reply": "Reply",
    "support.original": "Original",
    "view.mode": "View",
    "view.cards": "Cards",
    "view.table": "Table",
    "view.save": "Save Excel",
    "view.empty": "Nothing here yet.",
    "view.truncated": "Showing the first 3,000 rows; tap “Save Excel” for everything.",
    "view.hint": "Swipe the table left, right, up and down. To keep it or send it on, tap “Save Excel” at the top.",
    "file.copyLink": "Copy download link",
    "file.copyHint": "Then open Safari or Chrome and paste it into the address bar: the file downloads (no sign-in needed, valid for 10 minutes).",
    "file.copied": "Copied. Open Safari or Chrome and paste it into the address bar to download.",
    "file.hintAndroid": "Tap “Download”: the file is saved in your phone's Downloads. Tap the notification, or open it from Files › Downloads with Excel, WPS or Google Sheets.",
    "common.exportExcel": "Export to Excel",
    "admin.inquiries.title": "Business requests",
    "admin.inquiries.none": "No requests yet.",
    "admin.inquiries.done": "Mark as handled",
    "admin.inquiries.reopen": "Mark as open",
    "legal.privacy": "Privacy policy",
    "legal.terms": "Terms of use",
    "legal.refund": "Refund policy",
    "legal.imprint": "Company details",
    "legal.missing": "(to be added)",
    "legal.englishNote": "This page is shown in English.",
    "health.consent.title": "Before you use the food and health features",
    "health.consent.body": "Meals, meal photos, weight and body details are health data. Under EU privacy law (GDPR) we need your explicit consent before we store and process them.",
    "health.consent.what": "Stored: the meals and photos you log, weight, sex, birth year, height, exercise and steps.",
    "health.consent.why": "Only used to work out your calories, nutrients, energy use and today's health — never for advertising.",
    "health.consent.private": "Only you can see it; it is not shared with your family.",
    "health.consent.withdraw": "You can withdraw your consent under “Me” at any time, or delete these records.",
    "health.consent.agree": "I agree to the processing of my health data",
    "health.consent.notNow": "Not now, back to home",
    "health.consent.given": "Health data: consent given",
    "health.consent.givenSub": "Tap to withdraw",
    "health.consent.withdrawBody": "After withdrawing, the food and health features stop and we no longer process new health data. Meals and weights already saved can be deleted on the food pages, or delete your whole account.",
    "health.consent.withdrawBtn": "Withdraw consent",
    "health.consent.withdrawn": "Consent withdrawn.",
    "error.family_needs_plus": "This family has no Plus right now, so you can't join yet. Ask whoever subscribes in the family to renew.",
    "account.family": "Family",
    "account.familyInvite": "Invite your family",
    "account.familySub": "Share list, budget, pantry, things at home and one Plus",
    "error.family_full": "This family already has {max} people.",
    "error.list_has_members": "Your own list is shared with family, so you can't join another one. Stop sharing it first.",
    "ocr.failNoReads": "This month's AI reading help ({limit}) is used up; it's back on the 1st. Until then only the phone reads: straight on, in good light and a bit closer usually does it.",
    "ocr.withAi": "The phone couldn’t read it — asking the AI to help…",
    "error.ai_reads_reached": "This month’s {limit} AI reads are used up; they’re back on the 1st. You can type or check the values yourself.",
    "ocr.preparing": "Getting the on-phone reader ready (about 7 MB the first time)…",
    "auth.remember": "Stay signed in for 30 days",
    "auth.rememberSub": "Keeps you signed in while you use the app. Untick on someone else’s computer.",
    "error.crashTitle": "Oops, something went wrong on this page",
    "error.crashBody": "Your data is safe. Tap below to open the page again; we’ve been told about the problem automatically.",
    "error.crashReload": "Open again",
    "photo.drop": "Drag a photo here, or click to choose a file",
    "photo.dropSub": "You can also paste it (⌘V / Ctrl+V). Taking it with your phone is easiest.",
    "photo.file": "Choose another photo",
    "error.ai_daily_limit_trial": "During the trial you get {limit} photo estimate a day; try again tomorrow. Plus gives you {plus} a day (breakfast, lunch, dinner). Scanning a barcode, snapping a pack or logging by hand are unlimited.",
    "ai.leftTodayTrial": "Trial: {limit} photo estimate a day, {n} left today. Plus gives you {plus} a day.",
    "error.ai_advice_limit": "You've had {limit} pieces of advice this month; more on the 1st. Your latest advice above still applies.",
    "error.ai_paused": "This month's AI estimates have all been used; they're back on the 1st. Scanning a barcode, snapping a pack or logging by hand still work.",
    "admin.cost.budget": "This month's safety limit: ${budget}. It grows with paying and trial members (everyone using their full allowance, plus 50%), so normal use never reaches it; you get an email at 80%. The minimum is AI_MONTHLY_BUDGET_USD in Railway.",
    "admin.statGroup.people": "People",
    "admin.statGroup.money": "Subscriptions & revenue",
    "admin.statGroup.usage": "Usage",
    "admin.stat.users": "Accounts",
    "admin.stat.newThisWeek": "New this week",
    "admin.stat.newThisMonth": "New this month",
    "admin.stat.activeThisWeek": "Signed in this week",
    "admin.stat.revenuePerMonthEur": "Subscription revenue / month (incl. VAT)",
    "admin.stat.subscribersYearly": "Yearly subscribers",
    "admin.stat.subscribersMonthly": "Monthly subscribers",
    "admin.stat.inTrial": "In trial",
    "admin.stat.gifted": "Gifted Plus",
    "admin.stat.freeOnly": "Free features only",
    "admin.stat.revenueHint": "Revenue is an estimate: monthly subscribers × €9.99 + (yearly subscribers × €89, founding members × €69) ÷ 12, before Stripe fees and VAT. Stripe shows what actually arrives.",
    "admin.members.title": "Members",
    "admin.members.search": "Search email or name",
    "admin.members.filter": "Filter by status",
    "admin.members.s.all": "All",
    "admin.members.s.subscriber": "Subscribed",
    "admin.members.s.trial": "Trial",
    "admin.members.s.gifted": "Gifted",
    "admin.members.s.free": "Free",
    "admin.members.s.admin": "Admin",
    "admin.members.none": "No members match.",
    "admin.members.first100": "Showing the newest 100; search to narrow it down.",
    "admin.members.subYear": "Yearly plan",
    "admin.members.subMonth": "Monthly plan",
    "admin.members.giftedUntil": "Gifted Plus until {date}",
    "admin.members.giftedForever": "Gifted Plus, no end date",
    "admin.members.trialUntil": "Trial until {date}",
    "admin.members.joined": "Joined {date}",
    "admin.members.status": "Status",
    "admin.members.since": "Joined",
    "admin.members.lastLogin": "Last sign-in",
    "admin.members.isAdmin": "Admins can already use everything.",
    "admin.members.giftTitle": "Give Plus for free",
    "admin.members.giftHint": "For friends, testers and partners. No payment needed while it lasts; afterwards they go back to what they had (subscription, trial or free).",
    "admin.members.for.1": "1 month",
    "admin.members.for.3": "3 months",
    "admin.members.for.12": "1 year",
    "admin.members.for.forever": "No end",
    "admin.members.for.date": "Pick a date",
    "admin.members.until": "Until (day included)",
    "admin.members.endsOn": "Until {date}",
    "admin.members.noEnd": "No end date, until you take it back.",
    "admin.members.note": "Note (only admins see it)",
    "admin.members.noteHint": "e.g. tester, partner Albert Heijn",
    "admin.members.grant": "Give Plus",
    "admin.members.change": "Save changes",
    "admin.members.granted": "Plus given",
    "admin.members.revoke": "Take back",
    "admin.members.revoked": "Gift ended",
    "ads.label": "Ad · Partner",
    "ads.close": "Close this ad (hidden for 7 days)",
    "ads.open": "See the offer",
    "admin.partner.placements": "Where to show it",
    "admin.placement.home": "Home",
    "admin.placement.list": "Shopping list",
    "admin.placement.places": "Shops nearby",
    "admin.placement.fridge": "Pantry",
    "admin.partner.endsOn": "Ad end date",
    "admin.partner.endsOnHint": "Stops showing after this day; leave empty to keep showing",
    "admin.partner.until": "until {date}",
    "admin.ads.title": "Ad statistics",
    "admin.ads.month": "Month",
    "admin.ads.hint": "Only counts are kept — never who saw or clicked. Each place shows views/clicks.",
    "admin.ads.none": "No ads shown this month yet.",
    "admin.ads.partner": "Partner",
    "admin.ads.views": "Views",
    "admin.ads.clicks": "Clicks",
    "admin.ads.ctr": "Click rate",
    "admin.ads.download": "Download this month's ad report (opens in Excel)",
    "admin.ads.downloaded": "Report downloaded",
    "admin.cost.title": "AI costs",
    "admin.cost.spent": "Spent this month",
    "admin.cost.projected": "Heading for",
    "admin.cost.calls": "AI calls this month ({food} meal photos)",
    "admin.cost.perUser": "Per paying member ({n})",
    "admin.cost.recommend": "Suggested monthly spend limit in the Anthropic console: ${usd}",
    "admin.cost.how": "console.anthropic.com → Limits → Spend limit. About 2.5× the expected spend: normal use never reaches it, runaway use is stopped. It grows with your members — check it once a month.",
    "admin.cost.details": "Last month: ${last}; about ${perCall} per call. Worst case (every paying and trial member uses their full allowance): about ${worst} a month. Estimates in USD; the Anthropic invoice is what counts.",
    "ai.leftToday": "{n} photo estimates left today ({limit} a day: breakfast, lunch, dinner)",
    "error.ai_daily_limit": "You've used today's {limit} photo estimates; they're back tomorrow. Scanning a barcode, snapping a pack or logging by hand still work, as often as you like.",
    "account.clock": "Date and time",
    "account.clockZone": "Time zone: {zone}. Every date and time in the app follows this phone's clock; if it's wrong, turn on “Set automatically” in your phone's date & time settings.",
    "admin.reset": "Reset a member's password",
    "admin.resetHint": "When someone forgot their password and can't get the e-mail: enter their sign-up e-mail to make a reset link (valid 24 hours, works once), then send it to them by message.",
    "admin.resetMake": "Make reset link",
    "admin.resetMade": "Link ready",
    "admin.copy": "Copy link",
    "admin.copied": "Copied",
    "admin.copyManually": "Press and hold the link above to copy it",
    "auth.title.login": "Sign in",
    "auth.title.register": "Create an account",
    "auth.title.forgot": "Forgot your password?",
    "auth.title.reset": "Choose a new password",
    "auth.submit.login": "Sign in",
    "auth.submit.register": "Create account",
    "auth.submit.forgot": "Send reset e-mail",
    "auth.submit.reset": "Save and sign in",
    "auth.forgot": "Forgot password?",
    "auth.forgotIntro": "Enter the e-mail you signed up with. We'll send a link to choose a new password.",
    "auth.resetIntro": "Type your new password twice.",
    "auth.forgotSent": "If {email} has a NutriCart account, a reset e-mail is on its way. The link works for 1 hour. Check your spam folder if it doesn't arrive.",
    "auth.forgotUnavailable": "Password reset e-mails aren't set up yet. Please ask the administrator to reset your password.",
    "auth.backToLogin": "Back to sign in",
    "auth.newPassword": "New password",
    "auth.confirmPassword": "Type the password again",
    "auth.passwordMismatch": "The two passwords don't match.",
    "auth.showPassword": "Show password",
    "auth.hidePassword": "Hide password",
    "error.reset_link_invalid": "This reset link no longer works (older than 1 hour or already used). Please request a new one.",
    "error.mail_failed": "The e-mail couldn't be sent right now. Please try again later.",
    "reminder.openList": "Open the shopping list",
    "error.already_fasting": "You're already fasting.",
    "error.not_fasting": "There's no fast running right now.",
    "error.end_before_start": "The end has to be after the start.",
    "error.time_out_of_range": "The time can't be in the future or more than 3 days ago.",
    "common.retrying": "Reconnecting…",
    "common.offlineBar": "No connection, reconnecting…",
    "common.updateBar": "New version",
    "common.updateNow": "Update",
    "common.refresh": "Refresh",
    "common.back": "Back",
    "common.close": "Close",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.saved": "Saved",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.done": "Done",
    "common.retry": "Try again",
    "common.loading": "Loading…",
    "common.restore": "Restore",
    "common.restored": "Restored",
    "common.undo": "Undo",
    "common.trash": "Trash",
    "common.movedToTrash": "Moved to trash",
    "common.deleteForever": "Delete forever",
    "common.search": "Search",
    "common.showAll": "Show all · {n}",
    "common.showLess": "Show less",
    "common.optional": "optional",
    "common.today": "Today",
    "common.yesterday": "Yesterday",
    "common.more": "More",
    "common.continue": "Continue",
    "common.yes": "Yes",
    "common.no": "No",
    "common.discardTitle": "Discard your changes?",
    "common.discardBody": "Anything you haven't saved will be lost.",
    "common.discard": "Discard",
    "common.keepEditing": "Keep editing",

    "nav.home": "Home",
    "nav.shopping": "List",
    "nav.ledger": "Money",
    "nav.meals": "Meals",
    "nav.fridge": "Pantry",
    "nav.me": "Me",

    "error.generic": "Something went wrong. Please try again.",
    "error.already_subscribed": "You already have Plus. To switch between monthly and yearly, use Manage subscription.",
    "error.no_subscription": "We couldn't find your subscription. If you've just paid, wait a minute and try again.",
    "error.photo_limit": "That's a lot of photos for one day ({limit}). Carry on tomorrow.",
    "error.subscription_cancel_failed": "Your Plus subscription couldn't be cancelled just now, so your account hasn't been deleted (so you won't keep being charged). Try again later, or cancel it first under Manage subscription.",
    "file.ready": "Your Excel file is ready",
    "file.share": "Save or send",
    "file.hint": "Easiest: tap “Save or send” and choose “Save to Files”, open it in Excel or Numbers, or send it by mail or chat. Or tap “Download”: the file opens in a new window — “More…” or the share button saves it to Files or opens it in Excel; tap “Done” at the top to come back to the app.",
    "file.failed": "This phone couldn't open the share menu ({code}). Tap “Download” instead.",
    "file.download": "Download",
    "file.hintDownload": "Tap “Download”: the file opens in a new window — “More…” or the share button saves it to Files or opens it in Excel, Numbers or WPS; tap “Done” at the top (or close the page) to come back to the app.",
    "file.inWechat": "You opened the app inside WeChat, which can't save files. Tap “···” at the top right, choose to open it in your browser (Safari on an iPhone), and export again.",
    "file.inApp": "You opened the app inside another app, which may not save files. Open it in Safari or Chrome and export again.",
    "error.offline": "Can't reach the server. Check your connection and try again.",
    "error.timeout": "This took too long, so it was stopped. Try again, or fill it in yourself.",
    "error.cancelled": "Cancelled.",
    "error.server_error": "The server had a problem. Please try again later.",
    "error.not_found": "This item no longer exists.",
    "error.invalid_input": "Please check what you entered.",
    "error.invalid_input_detail": "Please check what you entered ({detail}).",
    "error.rate_limited": "That was a lot at once. Please wait a moment.",
    "error.not_signed_in": "Please sign in first.",
    "error.forbidden": "You don't have permission to do that.",
    "error.too_large": "That file is too large.",
    "error.photo_too_large": "That photo is too large. Try another one.",
    "error.invalid_photo": "That photo can't be used. Try another one.",
    "error.wrong_credentials": "Email or password is incorrect.",
    "error.email_taken": "This email already has an account. Sign in instead.",
    "error.ai_not_configured": "Photo reading isn't switched on yet. Please fill in the details by hand.",
    "error.ai_quota_reached": "You've used this month's {limit} AI reads. They reset on the 1st. Manual entry still works.",
    "error.ai_refused": "The AI couldn't process this image. Please fill in the details by hand.",
    "error.ai_incomplete": "The AI couldn't finish reading it. Try again or fill it in by hand.",
    "error.ai_unavailable": "The AI service is unavailable right now. Try again later or fill it in by hand.",
    "error.upstream_error": "An outside service isn't responding. Please try again later.",
    "error.download_failed": "Download failed. Please try again.",
    "error.date_in_future": "The date can't be in the future.",
    "error.free_sugar_exceeds_sugar": "Free sugars can't be more than total sugars.",
    "error.sugar_exceeds_carbs": "Sugars can't be more than carbohydrates.",
    "error.min_exceeds_max": "The minimum can't be higher than the maximum.",
    "error.reserve_exceeds_ceiling": "The essentials reserve can't be higher than the budget ceiling.",
    "error.card_needs_code_or_photo": "Add a card number, a barcode or a photo.",

    "photo.camera": "Camera",
    "photo.library": "Photos / file",
    "photo.remove": "Remove photo",
    "photo.preparing": "Preparing photo…",
    "photo.unreadable": "That image couldn't be read. Try a JPG or PNG.",

    "usage.title": "AI use",
    "usage.count": "{used} / {limit}",
    "usage.left": "{n} left, {when}.",
    "usage.none": "All used, {when}.",
    "usage.daily": "resets every night at midnight",
    "usage.monthly": "resets on the 1st of each month",
    "usage.food": "Meal photo estimates today",
    "usage.foodNote": "One each for breakfast, lunch and dinner.",
    "usage.advice": "Spending advice this month",
    "usage.adviceNote": "Looking again when your figures haven't changed doesn't count.",
    "usage.total": "AI this month (meal photos + advice)",
    "usage.totalNote": "",
    "usage.reads": "AI reading help this month (receipts, labels, cards)",
    "usage.readsNote": "Only used when your phone can't read a photo itself; what the phone reads doesn't count.",
    "usage.trialPaid": "You've subscribed to Plus. Once the trial ends and the first payment goes through, you get the Plus limits: {food} meal photos a day, {total} AI uses a month and {reads} reading helps.",
    "usage.trialMore": "With Plus: {food} meal photos a day, {total} AI uses a month and {reads} reading helps.",
    "usage.free": "Unlimited and never counted: barcode scans, receipts and labels read by your phone, logging by hand, the shopping list, card wallet and nearby shops. Reading the same photo again doesn't count either.",
    "error.community_rate_limit": "That's a bit fast: at most 5 posts and 30 comments an hour. Please try again a little later.",
    "ai.adviceLeft": "{n} pieces of spending advice left this month ({limit} a month, reset on the 1st; looking again without new spending doesn't count).",
    "ai.readsLeft": "When your phone can't read a photo, AI helps: {n} left this month ({limit} a month, reset on the 1st). What the phone reads itself doesn't count.",
    "ai.left": "{n} AI reads left this month",
    "ai.cached": "Used the earlier reading; no AI read was counted.",
    "ai.privacy": "The photo is sent to Anthropic's Claude to read it. It isn't used to train models.",

    "auth.tagline": "Shopping list, loyalty cards, household budget and healthy eating in one app.",
    "auth.login": "Sign in",
    "auth.register": "Create account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.passwordHint": "At least 8 characters",
    "auth.name": "What should we call you?",
    "auth.haveAccount": "Already have an account?",
    "auth.noAccount": "New here?",
    "auth.createAccount": "Create an account",
    "auth.passwordTooShort": "The password needs at least 8 characters.",

    "home.hello": "Hi {name}",
    "home.helloAnon": "Hi there",
    "home.prompt": "What would you like to do?",
    "home.shopping": "Shopping list",
    "home.shopping.sub": "Plan before you shop",
    "home.cards": "Loyalty cards",
    "home.cards.sub": "Show at checkout",
    "home.fridge": "Pantry",
    "home.goods": "Home goods",
    "home.fridge.sub": "Nutrition, dates and restocking",
    "home.receipt": "Scan a receipt",
    "home.receipt.sub": "Photo or by hand",
    "home.ledger": "Household budget",
    "home.ledger.sub": "Spending, budgets, reports",
    "home.meals": "Meals",
    "home.meals.sub": "Log your meals",
    "home.places": "Shops nearby",
    "home.places.sub": "Supermarkets & partners",
    "home.board": "Neighbours",
    "home.board.sub": "Food, swaps, help",
    "home.monthSpent": "Spent this month",
    "home.listOpen": "{n} items on your list",

    "reminder.title": "Before you head out",
    "reminder.sub": "Bags packed. Ready to go.",
    "reminder.bags": "Got your bags and your list? Check what's left in the pantry.",
    "reminder.keys": "Keys, phone and wallet?",
    "reminder.stove": "Hob and appliances switched off?",
    "reminder.windows": "Windows and taps closed?",
    "reminder.wish": "Happy shopping, and see you soon!",

    "weather.enable": "Do you need an umbrella today?",
    "weather.enable.sub": "Turn on location for local weather tips",
    "weather.loading": "Getting the weather…",
    "weather.failed": "Weather couldn't update. Tap to try again.",
    "weather.denied": "Location is off, so there is no weather. Allow your browser to use location in your phone’s settings (Privacy → Location Services), then tap here.",
    "weather.now": "Now {temp}°C",
    "weather.storm": "Thunderstorms possible. Stay indoors if you can.",
    "weather.wind": "Very windy. Take care out there.",
    "weather.rain": "Rain likely in the next few hours. Take an umbrella.",
    "weather.fine": "Looks dry. Grab your shopping bag and go.",
    "weather.cool": "It's chilly, wear an extra layer.",
    "weather.warm": "It's hot, bring some water.",
    "weather.title": "Local weather",
    "weather.credit": "Data: MET Norway (CC BY 4.0)",
    "weather.privacy": "Your location is rounded to about 1 km and only used to look up the weather.",
    "weather.turnOff": "Turn off weather location",
    "weather.updated": "Updated {time}",

    "account.title": "Me",
    "account.features": "All features",
    "account.profile": "Profile",
    "account.name": "Name",
    "account.email": "Email",
    "account.language": "Language",
    "account.languageAuto": "Same as my phone",
    "account.textSize": "Text size",
    "account.textNormal": "Standard",
    "account.textLarge": "Large",
    "account.textXLarge": "Largest",
    "account.textHint": "All text and buttons in the app grow together, on this phone.",
    "account.theme": "Appearance",
    "account.themeAuto": "System",
    "account.themeLight": "Light",
    "account.themeDark": "Dark",
    "account.plan": "Membership",
    "account.aiUsage": "AI reads this month: {used} of {limit}",
    "account.password": "Change password",
    "account.currentPassword": "Current password",
    "account.newPassword": "New password",
    "account.passwordChanged": "Password changed. Other devices have been signed out.",
    "account.data": "My data",
    "account.export": "Export all my data (Excel)",
    "account.logout": "Sign out",
    "account.delete": "Delete account",
    "account.deleteBody": "Your account and all its data (budget, photos, cards, meals, posts) will be deleted for good. If you have a Plus subscription, it is cancelled too and you won't be charged again. Enter your password to confirm.",
    "account.deleteConfirm": "Delete for good",
    "account.install": "Add to home screen",
    "account.installBody": "iPhone: in Safari tap Share → Add to Home Screen. Android: in Chrome's menu choose Install app.",
    "account.admin": "Admin",
    "account.privacy": "Privacy",
    "account.privacyBody": "Only you can see your budget, photos and meals. They are stored on our servers in the EU. A photo or a summary of figures is sent to Anthropic's Claude only when you tap an AI button; messages to Contact us are answered by the AI helper. Neighbourhood posts are visible to people in the same city and are deleted after 7 days.",


    "admin.title": "Admin",
    "admin.stats": "Overview",
    "admin.moderation": "Reported posts",
    "admin.nothingReported": "Nothing has been reported.",
    "admin.reports": "reports",
    "admin.hidden": "Hidden",
    "admin.hide": "Hide",
    "admin.unhide": "Show again",
    "admin.partners": "Partner businesses",
    "admin.partner.name": "Name",
    "admin.partner.description": "Description",
    "admin.partner.offer": "Offer",
    "admin.partner.address": "Address",
    "admin.partner.city": "City",
    "admin.partner.url": "Website (https://…)",
    "admin.partner.category": "Type",
    "admin.partner.active": "Show in the app",
    "admin.stat.records": "Budget records",
    "admin.stat.aiCallsThisMonth": "AI calls this month",
    "admin.stat.photoMegabytes": "Photo storage (MB)",
  },
  nl: {
    "home.tagline": "Boodschappen, uitgaven en gezond eten in één app",
    "home.quick.title": "Snel",
    "home.quick.receipt": "Bon",
    "home.quick.list": "Op lijst",
    "home.quick.meal": "Maaltijd",
    "home.quick.pantry": "Voorraad",
    "home.freeLine": "Met een account altijd gratis: boodschappenlijst, klantenkaarten, in de buurt en buurtprikbord",
    "today.arrangeShort": "Ordenen",
    "common.needName": "Vul eerst de naam in",
    "free.board": "Buurtprikbord",
    "free.boardSub": "Eten delen, spullen ruilen en elkaar helpen met buren",
    "auth.terms": "Probeer alle functies 14 dagen gratis, zonder betaalgegevens; de boodschappenlijst, klantenkaarten, winkels in de buurt en het buurtprikbord zijn altijd gratis. Door je aan te melden ga je akkoord met de gebruiksvoorwaarden en de privacyverklaring. Je kunt alles altijd exporteren of verwijderen.",
    "home.all": "Alles",
    "home.more": "Meer",
    "focus.prev": "Vorige",
    "focus.next": "Volgende",
    "free.badge": "Gratis met account",
    "free.title": "Met een account altijd gratis",
    "free.intro": "Geen betaalkaart nodig. Ze blijven werken na de proefperiode en kosten nooit iets.",
    "free.shopping": "Boodschappenlijst",
    "free.shoppingSub": "Per afdeling, toevoegen met je stem, afvinken wat je kocht",
    "free.cards": "Klantenkaarten",
    "free.cardsSub": "Al je winkelkaarten bij elkaar, laat de streepjescode zien bij de kassa",
    "free.places": "In de buurt",
    "free.placesSub": "Winkels, restaurants en aanbiedingen in de buurt",
    "free.export": "Mijn gegevens exporteren",
    "free.exportSub": "Al je gegevens als Excel-bestand, wanneer je wilt",
    "free.support": "Contact",
    "free.supportSub": "Schrijf in je eigen taal, we antwoorden in jouw taal",
    "today.title": "Vandaag",
    "today.arrange": "Kaarten ordenen",
    "today.arrangeHint": "Zet met de pijlen bovenaan wat je het vaakst bekijkt; tik op het oog om een kaart te verbergen.",
    "today.up": "Omhoog",
    "today.down": "Omlaag",
    "today.show": "Kaart tonen",
    "today.hide": "Kaart verbergen",
    "today.health.title": "Gezondheid vandaag",
    "today.budget.title": "Budget deze maand",
    "today.budget.left": "over",
    "today.budget.over": "{amount} over budget",
    "today.budget.canSpend": "Deze maand nog {amount} te besteden",
    "today.budget.leftOver": "Die maand {amount} over",
    "today.budget.spentOf": "{spent} uitgegeven van {budget}",
    "today.budget.spent": "deze maand uitgegeven",
    "today.budget.empty": "Nog niets bijgehouden deze maand",
    "today.budget.start": "Maak een foto van een bon om te beginnen",
    "today.budget.setOne": "Stel een maandbudget in om te zien wat er over is",
    "today.budget.noBudget": "Nog geen budget",
    "today.budget.setOneLong": "Tik hieronder op “Budget instellen” en vul in hoeveel je per maand wilt uitgeven. De ring laat dan zien wat er over is, zoals een batterij.",
    "today.budget.perDay": "Nog {days} dagen tot het einde van de maand: ongeveer {amount} per dag.",
    "today.budget.pairIn": "Inkomsten",
    "today.budget.pairOut": "Uitgaven",
    "today.fridge.title": "Voorraad",
    "today.fridge.empty": "De voorraad is nog leeg",
    "today.fridge.emptySub": "Maak een foto van een bon of scan een streepjescode",
    "today.fridge.expired": "{n} over datum: weggooien",
    "today.fridge.check": "{n} over ten minste houdbaar: eerst controleren",
    "today.fridge.soon": "{n} bijna over datum: eerst opeten",
    "today.fridge.fresh": "Alles vers",
    "today.fridge.freshSub": "Niets dat bijna over datum is",
    "today.fridge.todoSub": "{n} items in de voorraad",
    "today.fridge.todoUnit": "aandacht",
    "today.fridge.itemsUnit": "items",
    "today.shopping.title": "Boodschappenlijst",
    "today.shopping.unit": "te kopen",
    "today.shopping.toBuy": "Nog {n} te kopen",
    "today.shopping.done": "Alles gekocht",
    "today.shopping.sub": "Even kijken voor je gaat; afvinken in de winkel",
    "error.frozen": "Het ligt in de vriezer: eerst ontdooien.",
    "error.expired": "Het is over de datum: invriezen maakt het niet veilig. Gooi het weg.",
    "support.title": "Contact",
    "support.stripSub": "Vragen of ideeën? Schrijf ons in je eigen taal",
    "support.intro": "De AI-helper antwoordt meteen. Wat hij niet kan beantwoorden, gaat naar iemand van ons team, die in jouw taal antwoordt (meestal binnen 1 werkdag). Je kunt een schermafbeelding toevoegen.",
    "support.ai": "AI-helper (automatisch, kan fouten maken)",
    "support.whatsapp": "Via WhatsApp",
    "support.waText": "Hallo, ik gebruik NutriCart en ",
    "support.empty": "Nog geen berichten. Schrijf je vraag hieronder.",
    "support.team": "NutriCart-team",
    "support.placeholder": "Je vraag of idee…",
    "support.photo": "Schermafbeelding",
    "support.send": "Versturen",
    "support.unread": "Het team heeft geantwoord ({n})",
    "support.inbox": "Klantberichten",
    "support.inboxEmpty": "Nog geen berichten.",
    "support.replyPh": "Antwoord in je eigen taal; het wordt vertaald",
    "support.reply": "Antwoorden",
    "support.original": "Origineel",
    "view.mode": "Weergave",
    "view.cards": "Kaarten",
    "view.table": "Tabel",
    "view.save": "Excel opslaan",
    "view.empty": "Hier staat nog niets.",
    "view.truncated": "De eerste 3.000 regels worden getoond; tik op „Excel opslaan” voor alles.",
    "view.hint": "Veeg de tabel naar links, rechts, omhoog en omlaag. Om hem te bewaren of door te sturen, tik bovenaan op „Excel opslaan”.",
    "file.copyLink": "Downloadlink kopiëren",
    "file.copyHint": "Open daarna Safari of Chrome en plak hem in de adresbalk: het bestand wordt gedownload (zonder inloggen, 10 minuten geldig).",
    "file.copied": "Gekopieerd. Open Safari of Chrome en plak hem in de adresbalk om te downloaden.",
    "file.hintAndroid": "Tik op „Downloaden”: het bestand komt in Downloads op je telefoon. Tik op de melding, of open het via Bestanden › Downloads met Excel, WPS of Google Spreadsheets.",
    "common.exportExcel": "Exporteren naar Excel",
    "admin.inquiries.title": "Aanvragen van ondernemers",
    "admin.inquiries.none": "Nog geen aanvragen.",
    "admin.inquiries.done": "Markeren als afgehandeld",
    "admin.inquiries.reopen": "Markeren als open",
    "legal.privacy": "Privacyverklaring",
    "legal.terms": "Gebruiksvoorwaarden",
    "legal.refund": "Terugbetalingsbeleid",
    "legal.imprint": "Bedrijfsgegevens",
    "legal.missing": "(volgt)",
    "legal.englishNote": "Deze pagina wordt in het Engels getoond.",
    "health.consent.title": "Voordat je de functies voor eten en gezondheid gebruikt",
    "health.consent.body": "Maaltijden, maaltijdfoto's, gewicht en lichaamsgegevens zijn gezondheidsgegevens. Volgens de Europese privacywet (AVG) hebben we je uitdrukkelijke toestemming nodig voordat we ze bewaren en verwerken.",
    "health.consent.what": "Bewaard: de maaltijden en foto's die je invoert, gewicht, geslacht, geboortejaar, lengte, sport en stappen.",
    "health.consent.why": "Alleen gebruikt om je calorieën, voedingsstoffen, verbruik en gezondheid van vandaag te berekenen — nooit voor reclame.",
    "health.consent.private": "Alleen jij ziet het; het wordt niet met je gezin gedeeld.",
    "health.consent.withdraw": "Je kunt je toestemming altijd intrekken onder „Mij”, of deze gegevens verwijderen.",
    "health.consent.agree": "Ik geef toestemming voor het verwerken van mijn gezondheidsgegevens",
    "health.consent.notNow": "Nu niet, terug naar start",
    "health.consent.given": "Gezondheidsgegevens: toestemming gegeven",
    "health.consent.givenSub": "Tik om in te trekken",
    "health.consent.withdrawBody": "Na intrekken stoppen de functies voor eten en gezondheid en verwerken we geen nieuwe gezondheidsgegevens meer. Opgeslagen maaltijden en gewichten kun je op de eetpagina's verwijderen, of verwijder je hele account.",
    "health.consent.withdrawBtn": "Toestemming intrekken",
    "health.consent.withdrawn": "Toestemming ingetrokken.",
    "error.family_needs_plus": "Dit gezin heeft nu geen Plus, dus meedoen kan nog niet. Vraag wie in het gezin geabonneerd is om te verlengen.",
    "account.family": "Gezin",
    "account.familyInvite": "Nodig je gezin uit",
    "account.familySub": "Deel lijst, huishoudboekje, voorraad, spullen en één Plus",
    "error.family_full": "Dit gezin heeft al {max} personen.",
    "error.list_has_members": "Je eigen lijst wordt met je gezin gedeeld, dus je kunt niet bij een andere. Stop eerst met delen.",
    "ocr.failNoReads": "De AI-leeshulp van deze maand ({limit}) is op; op de 1e kan het weer. Tot dan leest alleen de telefoon: recht van voren, goed licht en iets dichterbij werkt meestal.",
    "ocr.withAi": "De telefoon kon het niet lezen — de AI helpt even…",
    "error.ai_reads_reached": "De {limit} AI-leesbeurten van deze maand zijn op; op de 1e kan het weer. Je kunt de waarden zelf invullen of controleren.",
    "ocr.preparing": "De lezer op je telefoon wordt klaargezet (de eerste keer ongeveer 7 MB)…",
    "auth.remember": "30 dagen ingelogd blijven",
    "auth.rememberSub": "Je blijft ingelogd zolang je de app gebruikt. Vink uit op de computer van iemand anders.",
    "error.crashTitle": "Oeps, er ging iets mis op deze pagina",
    "error.crashBody": "Je gegevens zijn veilig. Tik hieronder om de pagina opnieuw te openen; het probleem is automatisch aan ons gemeld.",
    "error.crashReload": "Opnieuw openen",
    "photo.drop": "Sleep een foto hierheen, of klik om een bestand te kiezen",
    "photo.dropSub": "Plakken kan ook (⌘V / Ctrl+V). Met je telefoon een foto maken is het makkelijkst.",
    "photo.file": "Andere foto kiezen",
    "error.ai_daily_limit_trial": "Tijdens de proefperiode krijg je {limit} fotoschatting per dag; morgen kan het weer. Met Plus zijn het er {plus} per dag (ontbijt, lunch, avondeten). Barcode scannen, verpakking fotograferen of zelf invullen is onbeperkt.",
    "ai.leftTodayTrial": "Proefperiode: {limit} fotoschatting per dag, vandaag nog {n}. Met Plus zijn het er {plus} per dag.",
    "error.ai_advice_limit": "Je hebt deze maand {limit} keer advies gekregen; op de 1e kan het weer. Je laatste advies hierboven blijft gelden.",
    "error.ai_paused": "De AI-schattingen van deze maand zijn op; op de 1e kan het weer. Barcode scannen, verpakking fotograferen of zelf invullen blijft werken.",
    "admin.cost.budget": "Veiligheidslimiet deze maand: ${budget}. Groeit mee met betalende en proefleden (iedereen alles gebruikt, plus 50%), dus normaal gebruik haalt hem nooit; bij 80% krijg je een e-mail. Het minimum is AI_MONTHLY_BUDGET_USD in Railway.",
    "admin.statGroup.people": "Gebruikers",
    "admin.statGroup.money": "Abonnementen & omzet",
    "admin.statGroup.usage": "Gebruik",
    "admin.stat.users": "Accounts",
    "admin.stat.newThisWeek": "Nieuw deze week",
    "admin.stat.newThisMonth": "Nieuw deze maand",
    "admin.stat.activeThisWeek": "Deze week ingelogd",
    "admin.stat.revenuePerMonthEur": "Abonnementsomzet / maand (incl. btw)",
    "admin.stat.subscribersYearly": "Jaarabonnees",
    "admin.stat.subscribersMonthly": "Maandabonnees",
    "admin.stat.inTrial": "In proefperiode",
    "admin.stat.gifted": "Plus cadeau",
    "admin.stat.freeOnly": "Alleen gratis functies",
    "admin.stat.revenueHint": "Omzet is een schatting: maandabonnees × €9,99 + (jaarabonnees × €89, oprichters × €69) ÷ 12, vóór Stripe-kosten en btw. Stripe laat zien wat er echt binnenkomt.",
    "admin.members.title": "Leden",
    "admin.members.search": "Zoek op e-mail of naam",
    "admin.members.filter": "Filter op status",
    "admin.members.s.all": "Alle",
    "admin.members.s.subscriber": "Abonnee",
    "admin.members.s.trial": "Proef",
    "admin.members.s.gifted": "Cadeau",
    "admin.members.s.free": "Gratis",
    "admin.members.s.admin": "Beheerder",
    "admin.members.none": "Geen leden gevonden.",
    "admin.members.first100": "De nieuwste 100 worden getoond; zoek om te verfijnen.",
    "admin.members.subYear": "Jaarabonnement",
    "admin.members.subMonth": "Maandabonnement",
    "admin.members.giftedUntil": "Plus cadeau tot {date}",
    "admin.members.giftedForever": "Plus cadeau, zonder einddatum",
    "admin.members.trialUntil": "Proef tot {date}",
    "admin.members.joined": "Lid sinds {date}",
    "admin.members.status": "Status",
    "admin.members.since": "Lid sinds",
    "admin.members.lastLogin": "Laatst ingelogd",
    "admin.members.isAdmin": "Beheerders kunnen al alles gebruiken.",
    "admin.members.giftTitle": "Plus cadeau geven",
    "admin.members.giftHint": "Voor vrienden, testers en partners. Zolang het loopt hoeven ze niet te betalen; daarna krijgen ze weer wat ze hadden (abonnement, proef of gratis).",
    "admin.members.for.1": "1 maand",
    "admin.members.for.3": "3 maanden",
    "admin.members.for.12": "1 jaar",
    "admin.members.for.forever": "Zonder einde",
    "admin.members.for.date": "Kies datum",
    "admin.members.until": "Tot en met",
    "admin.members.endsOn": "Tot {date}",
    "admin.members.noEnd": "Geen einddatum, tot je het intrekt.",
    "admin.members.note": "Notitie (alleen voor beheerders)",
    "admin.members.noteHint": "bijv. tester, partner Albert Heijn",
    "admin.members.grant": "Plus geven",
    "admin.members.change": "Wijzigingen opslaan",
    "admin.members.granted": "Plus gegeven",
    "admin.members.revoke": "Intrekken",
    "admin.members.revoked": "Cadeau beëindigd",
    "ads.label": "Advertentie · Partner",
    "ads.close": "Advertentie sluiten (7 dagen verborgen)",
    "ads.open": "Bekijk de aanbieding",
    "admin.partner.placements": "Waar tonen",
    "admin.placement.home": "Start",
    "admin.placement.list": "Boodschappenlijst",
    "admin.placement.places": "Winkels in de buurt",
    "admin.placement.fridge": "Voorraad",
    "admin.partner.endsOn": "Einddatum advertentie",
    "admin.partner.endsOnHint": "Wordt na deze dag niet meer getoond; leeg = blijft staan",
    "admin.partner.until": "tot {date}",
    "admin.ads.title": "Advertentiecijfers",
    "admin.ads.month": "Maand",
    "admin.ads.hint": "Alleen aantallen — nooit wie iets zag of aanklikte. Per plek: weergaven/klikken.",
    "admin.ads.none": "Deze maand nog geen advertenties getoond.",
    "admin.ads.partner": "Partner",
    "admin.ads.views": "Weergaven",
    "admin.ads.clicks": "Klikken",
    "admin.ads.ctr": "Klikratio",
    "admin.ads.download": "Advertentierapport van deze maand downloaden (opent in Excel)",
    "admin.ads.downloaded": "Rapport gedownload",
    "admin.cost.title": "AI-kosten",
    "admin.cost.spent": "Uitgegeven deze maand",
    "admin.cost.projected": "Verwacht eind van de maand",
    "admin.cost.calls": "AI-aanroepen deze maand ({food} maaltijdfoto's)",
    "admin.cost.perUser": "Per betalend lid ({n})",
    "admin.cost.recommend": "Aanbevolen maandlimiet in de Anthropic-console: ${usd}",
    "admin.cost.how": "console.anthropic.com → Limits → Spend limit. Ongeveer 2,5× de verwachte kosten: normaal gebruik haalt dat nooit, ontspoord gebruik wordt gestopt. Het groeit mee met je leden — kijk er elke maand even naar.",
    "admin.cost.details": "Vorige maand: ${last}; gemiddeld ${perCall} per aanroep. Slechtste geval (alle betalende en proefleden gebruiken alles): ongeveer ${worst} per maand. Schattingen in USD; de factuur van Anthropic telt.",
    "ai.leftToday": "Nog {n} fotoschattingen vandaag ({limit} per dag: ontbijt, lunch, avondeten)",
    "error.ai_daily_limit": "Je {limit} fotoschattingen van vandaag zijn op; morgen kun je weer. Barcode scannen, verpakking fotograferen of zelf invullen kan zo vaak je wilt.",
    "account.clock": "Datum en tijd",
    "account.clockZone": "Tijdzone: {zone}. Alle datums en tijden in de app volgen de klok van deze telefoon; klopt die niet, zet dan “Automatisch instellen” aan bij datum en tijd in je telefoon.",
    "admin.reset": "Wachtwoord van een lid herstellen",
    "admin.resetHint": "Als iemand zijn wachtwoord kwijt is en de e-mail niet krijgt: vul het e-mailadres in voor een herstellink (24 uur geldig, één keer te gebruiken) en stuur die per bericht door.",
    "admin.resetMake": "Herstellink maken",
    "admin.resetMade": "Link klaar",
    "admin.copy": "Link kopiëren",
    "admin.copied": "Gekopieerd",
    "admin.copyManually": "Houd de link hierboven ingedrukt om te kopiëren",
    "auth.title.login": "Inloggen",
    "auth.title.register": "Maak een account",
    "auth.title.forgot": "Wachtwoord vergeten?",
    "auth.title.reset": "Kies een nieuw wachtwoord",
    "auth.submit.login": "Inloggen",
    "auth.submit.register": "Account maken",
    "auth.submit.forgot": "Herstelmail sturen",
    "auth.submit.reset": "Opslaan en inloggen",
    "auth.forgot": "Wachtwoord vergeten?",
    "auth.forgotIntro": "Vul het e-mailadres in waarmee je je hebt aangemeld. We sturen een link om een nieuw wachtwoord te kiezen.",
    "auth.resetIntro": "Typ je nieuwe wachtwoord twee keer.",
    "auth.forgotSent": "Als {email} een NutriCart-account heeft, is er een herstelmail onderweg. De link werkt 1 uur. Kijk ook in je spammap.",
    "auth.forgotUnavailable": "Herstelmails zijn nog niet ingesteld. Vraag de beheerder om je wachtwoord opnieuw in te stellen.",
    "auth.backToLogin": "Terug naar inloggen",
    "auth.newPassword": "Nieuw wachtwoord",
    "auth.confirmPassword": "Typ het wachtwoord nog een keer",
    "auth.passwordMismatch": "De twee wachtwoorden zijn niet gelijk.",
    "auth.showPassword": "Wachtwoord tonen",
    "auth.hidePassword": "Wachtwoord verbergen",
    "error.reset_link_invalid": "Deze herstellink werkt niet meer (ouder dan 1 uur of al gebruikt). Vraag een nieuwe aan.",
    "error.mail_failed": "De e-mail kon nu niet worden verstuurd. Probeer het later opnieuw.",
    "reminder.openList": "Boodschappenlijst openen",
    "error.already_fasting": "Je bent al aan het vasten.",
    "error.not_fasting": "Er loopt nu geen vastenperiode.",
    "error.end_before_start": "Het einde moet na het begin liggen.",
    "error.time_out_of_range": "De tijd kan niet in de toekomst liggen of meer dan 3 dagen geleden zijn.",
    "common.retrying": "Opnieuw verbinden…",
    "common.offlineBar": "Geen verbinding, opnieuw verbinden…",
    "common.updateBar": "Nieuwe versie",
    "common.updateNow": "Bijwerken",
    "common.refresh": "Vernieuwen",
    "common.back": "Terug",
    "common.close": "Sluiten",
    "common.cancel": "Annuleren",
    "common.save": "Opslaan",
    "common.saved": "Opgeslagen",
    "common.delete": "Verwijderen",
    "common.edit": "Bewerken",
    "common.add": "Toevoegen",
    "common.done": "Klaar",
    "common.retry": "Opnieuw proberen",
    "common.loading": "Laden…",
    "common.restore": "Terugzetten",
    "common.restored": "Teruggezet",
    "common.undo": "Ongedaan maken",
    "common.trash": "Prullenbak",
    "common.movedToTrash": "Naar de prullenbak verplaatst",
    "common.deleteForever": "Definitief verwijderen",
    "common.search": "Zoeken",
    "common.showAll": "Alles tonen · {n}",
    "common.showLess": "Minder tonen",
    "common.optional": "optioneel",
    "common.today": "Vandaag",
    "common.yesterday": "Gisteren",
    "common.more": "Meer",
    "common.continue": "Verder",
    "common.yes": "Ja",
    "common.no": "Nee",
    "common.discardTitle": "Wijzigingen weggooien?",
    "common.discardBody": "Wat je nog niet hebt opgeslagen, gaat verloren.",
    "common.discard": "Weggooien",
    "common.keepEditing": "Verder bewerken",

    "nav.home": "Start",
    "nav.shopping": "Lijst",
    "nav.ledger": "Geld",
    "nav.meals": "Eten",
    "nav.fridge": "Voorraad",
    "nav.me": "Ik",

    "error.generic": "Er ging iets mis. Probeer het opnieuw.",
    "error.already_subscribed": "Je hebt Plus al. Wisselen tussen maand en jaar doe je via Abonnement beheren.",
    "error.no_subscription": "We konden je abonnement niet vinden. Net betaald? Wacht een minuutje en probeer het opnieuw.",
    "error.photo_limit": "Dat zijn veel foto's voor één dag ({limit}). Morgen kun je verder.",
    "error.subscription_cancel_failed": "Je Plus-abonnement kon nu niet worden opgezegd, dus je account is nog niet verwijderd (zodat er niet verder wordt afgeschreven). Probeer het later opnieuw of zeg eerst op via Abonnement beheren.",
    "file.ready": "Je Excel-bestand staat klaar",
    "file.share": "Bewaren of versturen",
    "file.hint": "Het makkelijkst: tik op „Bewaar of verstuur” en kies „Bewaar in Bestanden”, open het in Excel of Numbers, of stuur het per mail of chat. Of tik op „Downloaden”: het bestand opent in een nieuw venster — „Meer…” of de deelknop bewaart het in Bestanden of opent het in Excel; tik bovenaan op „Gereed” om terug te gaan naar de app.",
    "file.failed": "Deze telefoon kon het deelmenu niet openen ({code}). Tik op “Downloaden”.",
    "file.download": "Downloaden",
    "file.hintDownload": "Tik op „Downloaden”: het bestand opent in een nieuw venster — „Meer…” of de deelknop bewaart het in Bestanden of opent het in Excel, Numbers of WPS; tik bovenaan op „Gereed” (of sluit de pagina) om terug te gaan naar de app.",
    "file.inWechat": "Je hebt de app in WeChat geopend; WeChat kan geen bestanden bewaren. Tik rechtsboven op “···”, open hem in je browser (Safari op een iPhone) en exporteer opnieuw.",
    "file.inApp": "Je hebt de app in een andere app geopend, die misschien geen bestanden kan bewaren. Open hem in Safari of Chrome en exporteer opnieuw.",
    "error.offline": "Geen verbinding met de server. Controleer je internet en probeer opnieuw.",
    "error.timeout": "Dit duurde te lang en is gestopt. Probeer het opnieuw of vul het zelf in.",
    "error.cancelled": "Geannuleerd.",
    "error.server_error": "De server heeft een probleem. Probeer het later opnieuw.",
    "error.not_found": "Dit item bestaat niet meer.",
    "error.invalid_input": "Controleer wat je hebt ingevuld.",
    "error.invalid_input_detail": "Controleer wat je hebt ingevuld ({detail}).",
    "error.rate_limited": "Even rustig aan. Wacht een moment.",
    "error.not_signed_in": "Log eerst in.",
    "error.forbidden": "Je hebt hier geen toestemming voor.",
    "error.too_large": "Dit bestand is te groot.",
    "error.photo_too_large": "Deze foto is te groot. Probeer een andere.",
    "error.invalid_photo": "Deze foto kan niet worden gebruikt. Probeer een andere.",
    "error.wrong_credentials": "E-mailadres of wachtwoord klopt niet.",
    "error.email_taken": "Dit e-mailadres heeft al een account. Log in.",
    "error.ai_not_configured": "Foto's uitlezen staat nog niet aan. Vul de gegevens zelf in.",
    "error.ai_quota_reached": "Je {limit} AI-scans van deze maand zijn op. Op de 1e begin je opnieuw. Zelf invullen blijft werken.",
    "error.ai_refused": "De AI kon deze afbeelding niet verwerken. Vul de gegevens zelf in.",
    "error.ai_incomplete": "De AI kon het niet helemaal lezen. Probeer opnieuw of vul het zelf in.",
    "error.ai_unavailable": "De AI-dienst is nu niet bereikbaar. Probeer later opnieuw of vul het zelf in.",
    "error.upstream_error": "Een externe dienst reageert niet. Probeer het later opnieuw.",
    "error.download_failed": "Downloaden mislukt. Probeer opnieuw.",
    "error.date_in_future": "De datum kan niet in de toekomst liggen.",
    "error.free_sugar_exceeds_sugar": "Vrije suikers kunnen niet meer zijn dan de totale suikers.",
    "error.sugar_exceeds_carbs": "Suikers kunnen niet meer zijn dan koolhydraten.",
    "error.min_exceeds_max": "Het minimum kan niet hoger zijn dan het maximum.",
    "error.reserve_exceeds_ceiling": "De reserve voor vaste lasten kan niet hoger zijn dan het budgetplafond.",
    "error.card_needs_code_or_photo": "Vul een kaartnummer of streepjescode in, of voeg een foto toe.",

    "photo.camera": "Camera",
    "photo.library": "Foto's / bestand",
    "photo.remove": "Foto verwijderen",
    "photo.preparing": "Foto voorbereiden…",
    "photo.unreadable": "Deze afbeelding kon niet worden gelezen. Probeer een JPG of PNG.",

    "usage.title": "AI-gebruik",
    "usage.count": "{used} / {limit}",
    "usage.left": "Nog {n}, {when}.",
    "usage.none": "Op, {when}.",
    "usage.daily": "elke nacht om 0:00 weer aangevuld",
    "usage.monthly": "op de 1e van elke maand weer aangevuld",
    "usage.food": "Maaltijdfoto's vandaag",
    "usage.foodNote": "Eén voor ontbijt, lunch en avondeten.",
    "usage.advice": "Uitgavenadvies deze maand",
    "usage.adviceNote": "Opnieuw kijken zonder nieuwe uitgaven telt niet.",
    "usage.total": "AI deze maand (maaltijdfoto's + advies)",
    "usage.totalNote": "",
    "usage.reads": "AI-leeshulp deze maand (bonnen, etiketten, kaarten)",
    "usage.readsNote": "Alleen als je telefoon een foto zelf niet kan lezen; wat de telefoon leest, telt niet.",
    "usage.trialPaid": "Je hebt Plus. Zodra de proefperiode voorbij is en de eerste betaling gelukt is, krijg je de Plus-limieten: {food} maaltijdfoto's per dag, {total} keer AI per maand en {reads} keer leeshulp.",
    "usage.trialMore": "Met Plus: {food} maaltijdfoto's per dag, {total} keer AI per maand en {reads} keer leeshulp.",
    "usage.free": "Onbeperkt en nooit geteld: barcodes scannen, bonnen en etiketten die je telefoon leest, zelf invullen, boodschappenlijst, kaarten en winkels in de buurt. Dezelfde foto opnieuw lezen telt ook niet.",
    "error.community_rate_limit": "Iets te snel: maximaal 5 berichten en 30 reacties per uur. Probeer het straks nog eens.",
    "ai.adviceLeft": "Nog {n} keer uitgavenadvies deze maand ({limit} per maand, op de 1e weer aangevuld; opnieuw kijken zonder nieuwe uitgaven telt niet).",
    "ai.readsLeft": "Kan je telefoon een foto niet lezen, dan helpt AI: nog {n} deze maand ({limit} per maand, op de 1e weer aangevuld). Wat de telefoon zelf leest, telt niet.",
    "ai.left": "Nog {n} AI-scans deze maand",
    "ai.cached": "Eerdere uitlezing gebruikt; er is geen scan geteld.",
    "ai.privacy": "De foto wordt naar Claude van Anthropic gestuurd om hem te lezen. Hij wordt niet gebruikt om modellen te trainen.",

    "auth.tagline": "Boodschappenlijst, klantenkaarten, huishoudboekje en gezond eten in één app.",
    "auth.login": "Inloggen",
    "auth.register": "Account maken",
    "auth.email": "E-mailadres",
    "auth.password": "Wachtwoord",
    "auth.passwordHint": "Minstens 8 tekens",
    "auth.name": "Hoe mogen we je noemen?",
    "auth.haveAccount": "Heb je al een account?",
    "auth.noAccount": "Nieuw hier?",
    "auth.createAccount": "Maak een account",
    "auth.passwordTooShort": "Het wachtwoord moet minstens 8 tekens hebben.",

    "home.hello": "Hoi {name}",
    "home.helloAnon": "Hoi",
    "home.prompt": "Wat wil je doen?",
    "home.shopping": "Boodschappenlijst",
    "home.shopping.sub": "Plan voor je gaat",
    "home.cards": "Klantenkaarten",
    "home.cards.sub": "Laat zien bij de kassa",
    "home.fridge": "Voorraad",
    "home.goods": "Spullen",
    "home.fridge.sub": "Voedingswaarde, data en bijvullen",
    "home.receipt": "Bonnetje scannen",
    "home.receipt.sub": "Foto of zelf invullen",
    "home.ledger": "Huishoudboekje",
    "home.ledger.sub": "Uitgaven, budget, overzichten",
    "home.meals": "Eten",
    "home.meals.sub": "Houd je maaltijden bij",
    "home.places": "Winkels in de buurt",
    "home.places.sub": "Supermarkten & partners",
    "home.board": "Buurtprikbord",
    "home.board.sub": "Eten, ruilen, hulp",
    "home.monthSpent": "Deze maand uitgegeven",
    "home.listOpen": "{n} dingen op je lijst",

    "reminder.title": "Voor je de deur uitgaat",
    "reminder.sub": "Tassen mee. Klaar om te gaan.",
    "reminder.bags": "Tassen en lijstje mee? Kijk even wat er nog in de voorraad ligt.",
    "reminder.keys": "Sleutels, telefoon en portemonnee?",
    "reminder.stove": "Kookplaat en apparaten uit?",
    "reminder.windows": "Ramen en kranen dicht?",
    "reminder.wish": "Veel plezier met boodschappen doen, tot zo!",

    "weather.enable": "Paraplu nodig vandaag?",
    "weather.enable.sub": "Zet locatie aan voor weertips",
    "weather.loading": "Weer ophalen…",
    "weather.failed": "Het weer kon niet worden bijgewerkt. Tik om opnieuw te proberen.",
    "weather.denied": "Locatie staat uit, dus geen weer. Sta locatie toe voor je browser in de instellingen van je telefoon (Privacy → Locatievoorzieningen) en tik hier.",
    "weather.now": "Nu {temp}°C",
    "weather.storm": "Kans op onweer. Blijf zo mogelijk binnen.",
    "weather.wind": "Harde wind. Wees voorzichtig.",
    "weather.rain": "De komende uren kans op regen. Neem een paraplu mee.",
    "weather.fine": "Het blijft droog. Pak je boodschappentas en ga.",
    "weather.cool": "Het is fris, trek een extra laag aan.",
    "weather.warm": "Het is warm, neem water mee.",
    "weather.title": "Weer in de buurt",
    "weather.credit": "Gegevens: MET Norway (CC BY 4.0)",
    "weather.privacy": "Je locatie wordt afgerond op ongeveer 1 km en alleen gebruikt voor het weer.",
    "weather.turnOff": "Weerlocatie uitzetten",
    "weather.updated": "Bijgewerkt {time}",

    "account.title": "Ik",
    "account.features": "Alle functies",
    "account.profile": "Profiel",
    "account.name": "Naam",
    "account.email": "E-mailadres",
    "account.language": "Taal",
    "account.languageAuto": "Zelfde als mijn telefoon",
    "account.textSize": "Tekstgrootte",
    "account.textNormal": "Standaard",
    "account.textLarge": "Groot",
    "account.textXLarge": "Grootst",
    "account.textHint": "Alle tekst en knoppen in de app worden samen groter, op deze telefoon.",
    "account.theme": "Weergave",
    "account.themeAuto": "Systeem",
    "account.themeLight": "Licht",
    "account.themeDark": "Donker",
    "account.plan": "Lidmaatschap",
    "account.aiUsage": "AI-scans deze maand: {used} van {limit}",
    "account.password": "Wachtwoord wijzigen",
    "account.currentPassword": "Huidig wachtwoord",
    "account.newPassword": "Nieuw wachtwoord",
    "account.passwordChanged": "Wachtwoord gewijzigd. Andere apparaten zijn uitgelogd.",
    "account.data": "Mijn gegevens",
    "account.export": "Al mijn gegevens exporteren (Excel)",
    "account.logout": "Uitloggen",
    "account.delete": "Account verwijderen",
    "account.deleteBody": "Je account en al je gegevens (huishoudboekje, foto's, kaarten, maaltijden, berichten) worden definitief verwijderd. Heb je Plus, dan wordt dat abonnement ook opgezegd en wordt er niets meer afgeschreven. Vul je wachtwoord in om te bevestigen.",
    "account.deleteConfirm": "Definitief verwijderen",
    "account.install": "Op beginscherm zetten",
    "account.installBody": "iPhone: tik in Safari op Deel → Zet op beginscherm. Android: kies in het Chrome-menu App installeren.",
    "account.admin": "Beheer",
    "account.privacy": "Privacy",
    "account.privacyBody": "Alleen jij ziet je huishoudboekje, foto's en maaltijden. Ze staan op onze servers in de EU. Alleen als je op een AI-knop tikt, gaat een foto of een cijferoverzicht naar Claude van Anthropic; berichten aan Contact worden door de AI-helper beantwoord. Berichten op het buurtprikbord zijn zichtbaar voor mensen in dezelfde stad en worden na 7 dagen verwijderd.",


    "admin.title": "Beheer",
    "admin.stats": "Overzicht",
    "admin.moderation": "Gemelde berichten",
    "admin.nothingReported": "Er is niets gemeld.",
    "admin.reports": "meldingen",
    "admin.hidden": "Verborgen",
    "admin.hide": "Verbergen",
    "admin.unhide": "Weer tonen",
    "admin.partners": "Partnerbedrijven",
    "admin.partner.name": "Naam",
    "admin.partner.description": "Omschrijving",
    "admin.partner.offer": "Aanbieding",
    "admin.partner.address": "Adres",
    "admin.partner.city": "Plaats",
    "admin.partner.url": "Website (https://…)",
    "admin.partner.category": "Soort",
    "admin.partner.active": "Tonen in de app",
    "admin.stat.records": "Boekingen",
    "admin.stat.aiCallsThisMonth": "AI-aanroepen deze maand",
    "admin.stat.photoMegabytes": "Foto-opslag (MB)",
  },
} satisfies Dict;
